import { Leaf, ShieldCheck, Search, Globe, Users, FlaskConical, Sprout, Sun, Factory, Package, Home as HomeIcon, Droplets, Recycle, Award, HeartHandshake, Tractor, Microscope, BookOpen, ChefHat, GraduationCap, Newspaper, Wheat, Star } from "lucide-react";
import { IMG } from "./images";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/our-story", label: "Our Story" },
  { to: "/experience", label: "The Nutribest Experience" },
  { to: "/collection", label: "All Products" },
  { to: "/shop-by-category", label: "Shop by Category" },
  { to: "/quality-standard", label: "Our Quality Standard" },
  { to: "/farm-to-family", label: "From Farm to Family" },
  { to: "/sustainability", label: "Sustainability" },
  { to: "/academy", label: "Knowledge Centre" },
  { to: "/faq", label: "FAQ" },
];

export const VALUES = [
  { icon: Leaf, title: "Purity", text: "We select only the finest, natural ingredients — free from nasties." },
  { icon: Star, title: "Quality", text: "Uncompromising standards in every step we take." },
  { icon: ShieldCheck, title: "Transparency", text: "Honest communication and complete transparency. Always." },
  { icon: Globe, title: "Sustainability", text: "Responsible today for a healthier tomorrow." },
  { icon: Users, title: "Farmer Partnership", text: "Long-term relationships that uplift farmers and communities." },
  { icon: FlaskConical, title: "Science-Backed Nutrition", text: "Evidence-based approach for real health benefits." },
];

export const JOURNEY = [
  { icon: Sprout, title: "Seed", text: "We start with carefully selected seeds." },
  { icon: Tractor, title: "Farm", text: "Grown with care using responsible farming practices." },
  { icon: Sun, title: "Harvest", text: "Harvested at the right time for maximum nutrition." },
  { icon: Factory, title: "Processing", text: "Hygienic processing to preserve natural goodness." },
  { icon: FlaskConical, title: "Testing", text: "Rigorous testing for purity, safety and quality." },
  { icon: Package, title: "Packaging", text: "Packed with care to protect freshness and integrity." },
  { icon: HomeIcon, title: "Your Family", text: "Delivered to your home to support a healthy life." },
];

export const PROMISES = [
  "Every family deserves food they never have to question.",
  "If it isn't good enough for our own family, it isn't good enough for our customers.",
  "If it's from Nutribest, I don't need to worry about quality.",
];

export const TRUST_BAR = [
  { icon: Leaf, label: "Pure & Natural Ingredients" },
  { icon: ShieldCheck, label: "No Artificial Additives" },
  { icon: FlaskConical, label: "Lab Tested for Safety" },
  { icon: Package, label: "Hygienic Processing" },
  { icon: Recycle, label: "Food Safe Packaging" },
  { icon: HeartHandshake, label: "Ethical & Sustainable Practices" },
];

export const MARQUEE_ITEMS = [
  "Pure Nutrition. Real Superfoods.",
  "Earned Trust.",
  "If it's from Nutribest, I don't need to worry about quality.",
  "Grown with care. Delivered with honesty.",
  "Every family deserves food they never have to question.",
];

export const ACADEMY_CARDS = [
  { icon: Leaf, title: "Superfoods Encyclopedia", desc: "Discover nature's finest ingredients — in-depth guides on superfoods, their origin, nutrition, benefits, uses and much more.", tags: ["History & Origin", "Nutritional Profile", "Traditional Uses"], cta: "Explore Superfoods" },
  { icon: Wheat, title: "Nutrition Library", desc: "Understand what fuels your body. Learn about essential nutrients and their role in maintaining a healthy and balanced life.", tags: ["Protein", "Vitamins", "Minerals & Movement"], cta: "Explore Nutrition" },
  { icon: ChefHat, title: "Recipe Studio", desc: "Healthy recipes you'll love. Delicious and easy-to-make recipes using superfoods for everyday wellness.", tags: ["Breakfast Ideas", "Smoothies & Drinks", "Main Courses"], cta: "Explore Recipes" },
  { icon: Microscope, title: "Science Made Simple", desc: "Where nature meets research. We break down scientific studies into simple, honest and easy-to-understand insights.", tags: ["Research Summaries", "Evidence Explained", "What Science Says"], cta: "Explore Research" },
  { icon: Tractor, title: "Farm Wisdom", desc: "Learn from the source. Discover sustainable farming practices, soil health, harvesting and seasonal insights.", tags: ["Sustainable Farming", "Soil & Crop Care", "Harvesting Practices"], cta: "Explore Farming" },
  { icon: HeartHandshake, title: "Wellness Hub", desc: "Mind, body & lifestyle. Articles and guides to help you build a healthier, happier and more balanced lifestyle.", tags: ["Healthy Habits", "Sleep & Recovery", "Mindfulness & Detox"], cta: "Explore Wellness" },
  { icon: Newspaper, title: "The Nutribest Journal", desc: "Stories that inspire. Stay updated with the latest stories, news, innovations and insights from the Nutribest family.", tags: ["Behind the Scenes", "Farmer Stories", "Innovation Updates"], cta: "Read Journal" },
  { icon: GraduationCap, title: "Nutribest Learning Paths", desc: "Learn. Grow. Get Certified. Follow structured learning paths, complete lessons and earn your certificate.", tags: ["Moringa Expert", "Family Nutrition", "Sustainable Farming"], cta: "Start Learning", badge: "New" },
];

export const STATS = [
  { icon: Users, value: "100K+", label: "Nourished by Families" },
  { icon: GraduationCap, value: "25+", label: "Guided by Experts" },
  { icon: BookOpen, value: "100%", label: "Commitment to Better Living" },
];
